import styled from 'styled-components';
import {ButtonPrimary} from 'components/buttons';

export const UpsellHero = styled.div`
  position: relative;
  overflow: hidden;
  height: 341px;
  background-color: #fdeaea;
  border-radius: 10px;
  padding: 33px 430px 19px 20px;
  margin-top: 24px;

  @media (max-width: 1199px) {
    height: auto;
    padding: 28px 24px;
  }
`;

export const UpsellHeroText = styled.div`
  position: relative;
  z-index: 1;
  max-width: 540px;
`;

export const UpsellHeroLabel = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 130%;
  color: #ff2d38;
  margin-bottom: 12px;
`;

export const UpsellHeroTitle = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 30px;
  font-weight: 800;
  line-height: 100%;
  color: #2f3d48;
  margin: 0 0 20px 0;

  @media (max-width: 767px) {
    font-size: 24px;
  }
`;

export const UpsellHeroBody = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  color: #172751;
  margin: 0 0 28px 0;
`;

export const UpsellButton = styled(ButtonPrimary)`
  width: 100%;
  max-width: 271px;
  height: 52px;
  padding: 12px 15px;
  font-size: 16px;
  box-shadow: none;
`;

export const UpsellHeroImage = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: auto;

  @media (max-width: 1199px) {
    position: static;
    display: block;
    height: auto;
    width: 100%;
    max-width: 320px;
    margin: 24px -24px -28px auto;
  }
`;

export const UpsellSectionTitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 130%;
  color: #2f3d48;
  margin: 33px 0 16px 0;
`;

export const UpsellCards = styled.div`
  display: flex;
  align-items: stretch;
  gap: 24px;

  @media (max-width: 899px) {
    flex-direction: column;
  }
`;

export const UpsellCard = styled.div`
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  min-height: 175px;
  background-color: #fff;
  border-radius: 10px;
  padding: 17px 105px 56px 20px;
  overflow: hidden;
  box-shadow: 1px 10px 10px rgba(108, 49, 151, 0.08),
    10px 10px 20px rgba(108, 49, 151, 0.06);
`;

export const UpsellCardTitle = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 100%;
  color: #000;
  margin-bottom: 12px;
`;

export const UpsellCardText = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  color: #000;
  margin: 0;
`;

export const UpsellCardImage = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100px;
  height: 100px;
`;

export const UpsellFootnote = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 130%;
  color: #ff2d38;
  margin-top: 19px;
`;
